/** sessionStorage key: when the tab last reloaded for a missing chunk. */
export const RELOAD_FLAG = 'ub-chunk-reloaded';

/** One reload per deploy: a second chunk error within this window is genuine. */
const RELOAD_WINDOW_MS = 60_000;

/**
 * Records the reload and says whether one is allowed. The flag holds the time
 * of the last reload, so a later deploy in the same tab reloads again (the
 * old '1' flag was never cleared and blocked every later reload).
 */
export function mayReloadForChunk(now: number = Date.now()): boolean {
  try {
    const last = Number(sessionStorage.getItem(RELOAD_FLAG));
    if (Number.isFinite(last) && last > 1 && now - last < RELOAD_WINDOW_MS) return false;
    sessionStorage.setItem(RELOAD_FLAG, String(now));
    return true;
  } catch {
    return false;
  }
}
